// @ts-expect-error legacy
import {datetimeFormatter, defaultFormatter} from "@/pages/rum/v2/RumUtils";

// @ts-expect-error legacy
export const barLabelFormatter = (data, options, timezone) => {
  const timeKey = "EventTime";
  const ix = options.dataPointIndex;

  // Allow a max of 8 labels so they don't get cluttered (start, end, 6 in the middle).
  if (data.length > 8) {
    // @ts-expect-error legacy
    const everyNth = parseInt(data.length / 8) + 1;
    if (ix !== 0 && ix !== data.length - 1 && (ix % everyNth || ix > data.length - everyNth)) {
      return "";
    }
  }

  const thisPoint = data[ix];
  if (!thisPoint) {
    return "";
  }

  return datetimeFormatter(thisPoint[timeKey], data[0][timeKey], data[data.length - 1][timeKey], {
    timezone: timezone,
  });
};

// @ts-expect-error legacy
export const parseData = (data, left, right, baselines, bar, options, headerData) => {
  data = data || [];
  const dashArray = []; // Show features as solid lines and baselines as dotted lines.
  const series = []; // Data arrays.
  const timeKey = "EventTime";

  // @ts-expect-error unknown type
  const timePoints = data.map((datum) => {
    let timePoint = datum[timeKey];
    if (typeof timePoint === "string" && !timePoint.endsWith("Z")) {
      timePoint += "Z";
    }
    return new Date(timePoint);
  });

  let yaxis: Record<string, unknown>[];
  if (left) {
    const leftData = [];
    for (const [ix, datum] of data.entries()) {
      leftData.push([timePoints[ix], datum[left.key]]);
    }
    yaxis = [options.yaxis[0]];
    series.push({
      name: left.name,
      data: leftData,
      type: bar ? "column" : "line",
    });
    dashArray.push(0);
  } else {
    yaxis = [];
  }

  const rightLines = (right || []).concat(baselines || []);
  const rightSeries = [];
  // @ts-expect-error unknown type
  let firstFeature;
  for (const [ix, feature] of rightLines.entries()) {
    if (!data.length || !data[0][feature.key]) {
      continue;
    }

    let key, name, dash;
    if (ix < (right || []).length) {
      key = feature.key;
      name = feature.name;
      dash = 0;
    } else {
      // Hide the baselines if the user has selected a time range for which baselines are not applicable.
      if (headerData[feature.baseline] == null) {
        continue;
      }
      key = feature.baseline;
      name = `${feature.name} (baseline)`;
      dash = 2;
    }
    dashArray.push(dash);

    const featureData = [];
    for (const [ix, datum] of data.entries()) {
      // First, look for the data in the indexed data point.
      // Second, look for it in the header data (for baseline values).
      let value = datum[key];
      if (value === undefined && headerData) {
        value = headerData[key];
      }
      featureData.push([timePoints[ix], value]);
    }
    const thisSeries = {
      name,
      data: featureData,
      type: "line",
    };
    series.push(thisSeries);

    const opposite = !!left; // True if on right axis.
    if (opposite) {
      rightSeries.push(thisSeries);
    }

    const allUnits = new Set();
    for (const feature of right || []) {
      if (feature.units) {
        allUnits.add(feature.units);
      }
    }
    if (allUnits.size === 1) {
      firstFeature = right[0];
    }

    // https://apexcharts.com/docs/chart-types/multiple-yaxis-scales/#3-series-2-scales
    if (!firstFeature) {
      yaxis.push({
        seriesName: name,
        opposite,
        labels: {
          // @ts-expect-error unknown type
          formatter: (value) => defaultFormatter(value, 3, firstFeature),
        },
        tickAmount: 3,
      });
      firstFeature = name;
    } else {
      yaxis.push({
        seriesName: firstFeature,
        show: false,
        opposite,
      });
    }
  }

  // Apexcharts seems to handle rounded axis limits on shared axes incorrectly, so we'll set them manually based on the data.
  // The issue is with niceMax; the first opposite axis is correct, but the others are set to a different niceMax and it causes scaling issues.
  if (rightSeries.length) {
    let rightMax = Number.MIN_VALUE;
    for (const rSeries of rightSeries) {
      for (const value of rSeries.data) {
        rightMax = Math.max(rightMax, value[1]);
      }
    }
    if (rightMax !== Number.MIN_VALUE) {
      for (const axis of yaxis.filter((ax) => ax.opposite)) {
        axis.min = 0;
        axis.max = rightMax;
      }
    }
  }

  // If a dual-axis chart is rendered with no data, the axes will render incorrectly if the time range is shifted and data shows up.
  // Insert some placeholder data to work around this.
  const noData = !firstFeature;
  if (!firstFeature) {
    yaxis.push({
      seriesName: "null",
      opposite: !!left,
      labels: {
        // @ts-expect-error unknown type
        formatter: (value) => defaultFormatter(value, 3, firstFeature),
      },
    });
    series.push({
      name: "(No data found)",
      data: [],
      type: "line",
    });
  }

  return {series, yaxis, dashArray, noData};
};
